module.exports = __webpack_public_path__ + "resources/img/gift-code.3b2a9405.png";